import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import uzLatn from "../locales/uz-latn.json";

export const i18n = i18next.createInstance();

void i18n.use(initReactI18next).init({
  lng: "uz-Latn",
  fallbackLng: "uz-Latn",
  resources: {
    "uz-Latn": { translation: uzLatn },
  },
  interpolation: {
    escapeValue: false,
  },
});
